import { Link } from 'react-router-dom'
import { useLogout, useSession } from '@/hooks/useSession.js'
import { Habits } from '@/components/Habits/Habits.jsx'
import { Button } from '@/components/ui/button.jsx'
import { HamburgerMenuIcon } from '@radix-ui/react-icons'
import { motion } from 'framer-motion'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu.jsx'
import { apiHost } from '@/config.js'

export const HomePage = () => {
  const { data, isLoading, refetch } = useSession()
  const { mutate: logout } = useLogout()

  return (
    <div className="mx-auto flex w-full max-w-[640px] flex-1 flex-col px-4">
      <header className="flex items-center gap-1 pt-4">
        <motion.h1
          className="text-3xl font-semibold"
          whileHover={{
            letterSpacing: '0.2rem',
            scale: 1.1,
          }}
          whileTap={{
            letterSpacing: '0.1rem',
            scale: 0.9,
          }}
        >
          <Link to="/">habitus.dev</Link>
        </motion.h1>
        <div className="ml-auto hidden items-center gap-1">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button size="icon" variant="secondary">
                <HamburgerMenuIcon />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="max-w-52">
              {data?.session?.name && (
                <>
                  <DropdownMenuLabel>
                    <span className="line-clamp-4 overflow-hidden text-ellipsis">
                      {data.session.name}
                    </span>
                  </DropdownMenuLabel>
                  <DropdownMenuSeparator />
                </>
              )}
              <DropdownMenuGroup>
                {isLoading ? (
                  <DropdownMenuItem disabled>Loading session info...</DropdownMenuItem>
                ) : (
                  <>
                    {data?.session ? (
                      <DropdownMenuItem
                        onClick={() => {
                          return logout(undefined, {
                            onSettled() {
                              refetch()
                            },
                          })
                        }}
                      >
                        Logout
                      </DropdownMenuItem>
                    ) : (
                      <DropdownMenuItem asChild>
                        <Link to={`${apiHost}/api/auth/google/login`}>Login with Google</Link>
                      </DropdownMenuItem>
                    )}
                    {/* <DropdownMenuItem asChild>
                    <Link to="/settings">Settings</Link>
                  </DropdownMenuItem> */}
                  </>
                )}
              </DropdownMenuGroup>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </header>
      <Habits />
    </div>
  )
}
